import { makeAutoObservable } from 'mobx';
import { TimerStore } from './TimerStore';

export class UITimerStore {
  timersMap: Map<string, TimerStore>;

  _viewableTime?: number;
  _viewableDuration: number = 0;

  constructor() {
    this.timersMap = new Map<string, TimerStore>();
    makeAutoObservable(this, {
      _viewableDuration: false,
      _viewableTime: false
    });
  }

  addTimer(name: string, delay: number = 0): UITimerStore {
    this.timers.set(name, new TimerStore({ delay }));
    return this;
  }

  destroy(name: string) {
    this.timersMap.delete(name);
  }

  pause() {
    this.incrementViewableDuration();
    this.timersMap.forEach(timer => {
      if (!timer.isFinished) {
        timer.pause();
      }
    });
  }

  resume() {
    this.startViewableDuration();
    this.timersMap.forEach(timer => {
      if (!timer.isFinished) {
        timer.resume();
      }
    });
  }

  startViewableDuration(): void {
    this._viewableTime = Date.now();
  }

  incrementViewableDuration(): void {
    this._viewableDuration += this._viewableTime
      ? Date.now() - this._viewableTime
      : 0;
    this._viewableTime = undefined;
  }

  has(name: string) {
    return this.timersMap.has(name);
  }

  get(name: string) {
    return this.timersMap.get(name);
  }

  get timers() {
    return this.timersMap;
  }

  get viewableDuration(): number {
    return (
      this._viewableDuration +
      (this._viewableTime ? Date.now() - this._viewableTime : 0)
    );
  }
}
